import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function patientLoader({ params }: LoaderFunctionArgs) {
    const branchId = params.branchId!;
    const admissionId = params.admissionId!;
    if (branchId && admissionId) {
        try {
            const admission = await queryClient.fetchQuery({
                queryKey: ['branch', branchId, 'admission', admissionId, 'overview'],
                queryFn: async () => {
                    const { data } = await api.patientOverview.get(branchId, admissionId);
                    return data;
                },
            });
            return admission;
        } catch (error) {
            if ((error as Response).status === 404) {
                throw redirect('/patients');
            }
        }
    }
    return null;
}

export async function intakeLoader({ params }: LoaderFunctionArgs) {
    const branchId = params.branchId!;
    const admissionId = params.admissionId!;
    if (branchId && admissionId) {
        const admission = await queryClient.fetchQuery({
            queryKey: ['branch', branchId, 'admission', admissionId],
            queryFn: async () => {
                const { data } = await api.admission.get(branchId, admissionId);
                return data;
            },
        });
        return admission;
    }
    return null;
}
